export function VerifyPackageConfirmModal() {
    return (
        <div>
            <h5 className="mb-2">Do you want to verify this package?</h5>
            <p>After confirming, this package will be marked as verified.</p>
        </div>
    );
}
